export default __webpack_public_path__ + "static/media/element_10.86139dbd.jpg";